import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  CardHeader,
  Row,
  Container,
  Table,
} from "react-bootstrap";

import { Link } from "react-router-dom";
import { useCustomScreen, useScreenSize } from "../../../Components/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faCircleInfo,
  faFileImage,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";

export default function OrderConformationPage() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isLandscape1024, isPortrait1024 } = useCustomScreen();
  const devicePixelRatio = window.devicePixelRatio;
  const location = useLocation();
  const navigate = useNavigate();
 const orderDetails =
  location.state?.tempFormattedAddr ||
  JSON.parse(localStorage.getItem("orderDetails")) ||
  [];

const orderReportDetails = 
  location.state?.tempReportDetails ||
  JSON.parse(localStorage.getItem("orderReportDetails")) ||
  {};

  const notesData = [
    "You will receive an email confirmation of your purchase.",
    "We ask for one bussiness day (M-F) to complete your order.",
    "If you request a RUSH you will receive your order today.",
    "If you're RUSH needs more immediate please call 805-746-5823.",
  ];

  const subTotal = orderDetails
    .reduce((sum, order) => sum + order.itemPrice, 0)
    .toFixed(2);

  const totalPrice = orderDetails
    .reduce((sum, order) => sum + (order.discount - order.totalPrice || 0), 0)
    .toFixed(2);

  const discountPrice = orderDetails
    .reduce((sum, order) => sum + order.discount, 0)
    .toFixed(2);

  // const discountPrice = orderDetails[0].discount.toFixed(2);

  const rushCount = orderDetails.filter(
    (item) => item.delivery === "RUSH"
  ).length;

  const rushPrice = parseInt((rushCount * 15).toFixed(2));

  const paymentType = orderReportDetails.paymentType;
  const cardLastFourDigits = orderReportDetails.cardLastDigits;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  



 
  // useEffect(() => {
  //   const handleBack = () => {
  //     // Redirect to home on back
  //     setTimeout(() => { 
  //       navigate("/", { replace: true });
  //     }, 0);
  //   };

  //   // Attach after render (do not use navigate(...replace) here!)
  //   window.addEventListener("popstate", handleBack);

  //   return () => {
  //     window.removeEventListener("popstate", handleBack);
  //   };
  // }, [navigate]);
  // useEffect(() => {
  //   // Push a dummy state so "back" stays here
  //   window.history.pushState(null, "", window.location.href);

  //   const handlePopState = (event) => {
  //     // Trap the user by pushing the same state again
  //     window.history.pushState(null, "", window.location.href);
  //   };

  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, []);

  useEffect(() => {
    // Push dummy state so user has to go forward/back within confirmation page
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Redirect to /orders when user hits back
      navigate("/order-page", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div
      style={{
        height:
          is4kScreen && orderDetails.length <= 1
            ? "100vh"
            : is4kScreen && orderDetails.length > 1
            ? "auto"
            : isXxlScreen
            ? "auto"
            : isXlScreen
            ? "auto"
            : isLargeScreen && isPortrait1024
            ? "100vh"
            : isLargeScreen && devicePixelRatio >= 1.5
            ? "auto"
            : isLargeScreen
            ? "100vh"
            : isMediumScreen && isPortrait1024
            ? "100vh"
            : isMediumScreen
            ? "100vh"
            : "auto",
        paddingTop: is4kScreen
          ? "4rem"
          : isXxlScreen
          ? "5rem"
          : isXlScreen
          ? "6rem"
          : isLargeScreen && devicePixelRatio >= 1.5
          ? "4.5rem"
          : isMediumScreen
          ? " 5rem"
          : isSmallScreen
          ? "5.5rem"
          : "",
        marginBottom: isSmallScreen ? "1.5rem" : "",
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Container
        className="hide-scrollbar"
        style={{
          height: "95%",
          width: "80%",

          marginTop: is4kScreen ? "4rem" : "0rem",
          marginBottom: is4kScreen ? "2rem" : "0rem",
        }}
      >
        <Card
          className="scroll-hidebar "
          style={{
            height: "100%",
            overflowY: "scroll",
            display: "flex",
            justifyContent: "space-evenly",
            marginBottom: "1rem",
          }}
        >
          <CardHeader
            style={{
              textAlign: "center",
              fontSize: is4kScreen
                ? "3rem"
                : isXxlScreen
                ? "2rem"
                : isXlScreen
                ? "1.7rem"
                : isLargeScreen && isPortrait1024
                ? "1.9rem"
                : isLargeScreen
                ? "1.5rem"
                : "",
              backgroundColor: "lightblue",
              color: "#ffffff",
            }}
          >
            THANK YOU FOR YOUR ORDER!
          </CardHeader>
          <CardBody>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
              }}
            >
              <div className="">
                <h3>{}</h3>
                <h4
                  style={{
                    fontSize: is4kScreen
                      ? "2rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isLargeScreen && isPortrait1024
                      ? "1.5rem"
                      : isMediumScreen
                      ? " "
                      : "1.2rem",
                  }}
                >
                  Order Details
                </h4>
                <div>
                  {" "}
                  <hr style={{ minWidth: "100%" }} />
                </div>

                {orderDetails.map((order, indx) => {
                  return (
                    <div
                      key={indx + 1}
                      style={{ overflowX: isSmallScreen ? "scroll" : "" }}
                    >
                      <Table
                        striped
                        bordered
                        size="sm"
                        className="p-4 responsive-table"
                        style={{
                          minWidth: "100%",
                          tableLayout: "fixed",
                          overflowX: "auto",
                        }}
                      >
                        <thead style={{ backgroundColor: "lightgray" }}>
                          <tr style={{ backgroundColor: "lightgray" }}>
                            <th
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? "1rem"
                                  : isXlScreen
                                  ? ""
                                  : isLargeScreen && isPortrait1024
                                  ? "1.5rem"
                                  : isLargeScreen
                                  ? "1rem"
                                  : isMediumScreen
                                  ? ""
                                  : "",
                                padding: is4kScreen
                                  ? "1rem"
                                  : isXxlScreen || isXlScreen || isLargeScreen
                                  ? "0.5rem"
                                  : "",
                                minWidth: isLargeScreen ? "5rem" : "",
                              }}
                            >
                              Address
                            </th>
                            <th
                              className="text-center"
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? "1rem"
                                  : isXlScreen
                                  ? ""
                                  : isLargeScreen && isPortrait1024
                                  ? "1.5rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? ""
                                  : "",
                                padding:
                                  is4kScreen ||
                                  isXxlScreen ||
                                  isXlScreen ||
                                  isLargeScreen
                                    ? "0.5rem"
                                    : "",
                              }}
                            >
                              Report Type
                            </th>
                            <th
                              className="text-center"
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? "1rem"
                                  : isXlScreen
                                  ? ""
                                  : isLargeScreen && isPortrait1024
                                  ? "1.5rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? ""
                                  : "",
                                padding:
                                  is4kScreen ||
                                  isXxlScreen ||
                                  isXlScreen ||
                                  isLargeScreen
                                    ? "0.5rem"
                                    : "",
                              }}
                            >
                              QTY
                            </th>
                            <th
                              className="text-center"
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? "1rem"
                                  : isXlScreen
                                  ? ""
                                  : isLargeScreen && isPortrait1024
                                  ? "1.5rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? ""
                                  : "",
                                padding:
                                  is4kScreen ||
                                  isXxlScreen ||
                                  isXlScreen ||
                                  isLargeScreen
                                    ? "0.5rem"
                                    : "",
                              }}
                            >
                              Delivery Type
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          style={{
                            backgroundColor: "white",
                            "--bs-table-accent-bg": "white",
                            "--bs-table-striped-bg": "white",
                            borderColor: "lightgray",
                          }}
                        >
                          <>
                            <tr>
                              <td
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                }}
                              >
                                {order.streetAddress}, {order.city},{" "}
                                {order.state}, {order.zip}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                }}
                              >
                                {order.type.charAt(0).toUpperCase() +
                                  order.type.slice(1).toLowerCase()}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                }}
                              >
                                {order.quantity}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                }}
                              >
                                {order.delivery === "RUSH" ? "Rush" : "Normal"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                  width: "50%",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                }}
                              >
                                Report Details: {order.teamNote}
                              </td>
                              <td
                                colSpan={3}
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                  width: "50%",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                }}
                              >
                                CCEmails: {order.ccEmail}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={4}
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.7rem"
                                    : isLargeScreen && isPortrait1024
                                    ? "1.5rem"
                                    : "",
                                  padding: "0.7rem",
                                }}
                              >
                                Claims Number:{order.claimProjectNo}
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </Table>
                    </div>
                  );
                })}
              </div>
              <div
                className="pt-3"
                style={{ overflowX: isSmallScreen ? "scroll" : "" }}
              >
                <h4
                  style={{
                    fontSize: is4kScreen
                      ? "2rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isMediumScreen
                      ? " "
                      : "1.2rem",
                  }}
                >
                  Receipt
                </h4>
                <h5
                  style={{
                    fontSize: is4kScreen
                      ? "1.6rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.1rem"
                      : isLargeScreen
                      ? "0.95rem"
                      : isMediumScreen
                      ? " "
                      : "1.2rem",
                  }}
                >
                  {" "}
                  Paid with :{" "}
                  {`${
                    paymentType === 0
                      ? "Credits"
                      : paymentType === 1
                      ? `Card ${cardLastFourDigits}`
                      : "Promo"
                  }`}{" "}
                </h5>
                <hr style={{ width: "100%" }} />
                <Table
                  striped
                  bordered
                  size="sm"
                  className="p-4"
                  style={{
                    minWidth: "100%",
                    overflowY: "auto",
                    overflowX: "scroll",
                  }}
                >
                  <thead style={{ backgroundColor: "lightgray" }}>
                    <tr style={{ backgroundColor: "lightgray" }}>
                      <th
                        className="text-center "
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? "0.5rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                        }}
                      >
                        Product
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? "0.5rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? "0.5rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                        }}
                      >
                        Price
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                        }}
                      >
                        Credits
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? ""
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                        }}
                      >
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      backgroundColor: "white",
                      "--bs-table-accent-bg": "white",
                      "--bs-table-striped-bg": "white",
                      borderColor: "lightgray",
                    }}
                  >
                    {orderDetails.map((order, indx) => {
                      return (
                        <>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen ? "1.7rem" : "",
                              }}
                            >
                              {order.type.charAt(0).toUpperCase() +
                                order.type.slice(1).toLowerCase()}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen ? "1.7rem" : "",
                              }}
                            >
                              {order.quantity}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen ? "1.7rem" : "",
                              }}
                            >
                              ${order.itemPrice.toFixed(2)} USD
                            </td>

                            <td
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen ? "1.7rem" : "",
                              }}
                            >
                              {order.paymentType === 0 ? -order.quantity : 0}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen ? "1.7rem" : "",
                              }}
                            >
                              ${order.itemPrice.toFixed(2)} USD
                            </td>
                          </tr>
                        </>
                      );
                    })}
                    {rushCount > 0 ? (
                      <tr>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: is4kScreen ? "1.7rem" : "",
                          }}
                        >
                          Rush
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: is4kScreen ? "1.7rem" : "",
                          }}
                        >
                          {rushCount}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: is4kScreen ? "1.7rem" : "",
                          }}
                        >
                          $15.00 USD
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: is4kScreen ? "1.7rem" : "",
                          }}
                        ></td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: is4kScreen ? "1.7rem" : "",
                          }}
                        >
                          ${(rushCount * 15).toFixed(2)} USD
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    <tr>
                      <th></th>
                      <th></th>
                      <th
                        colSpan={"2"}
                        style={{
                          textAlign: "end",
                          fontSize: is4kScreen ? "1.7rem" : "",
                        }}
                      >
                        SubTotal
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: is4kScreen ? "1.7rem" : "",
                        }}
                      >
                        ${(parseInt(subTotal) + rushPrice).toFixed(2)} USD
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th
                        colSpan={"2"}
                        style={{
                          textAlign: "end",
                          fontSize: is4kScreen ? "1.7rem" : "",
                        }}
                      >
                        Discount
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: is4kScreen ? "1.7rem" : "",
                          color: parseInt(discountPrice) > 1 ? "green" : "",
                        }}
                      >
                        {parseInt(discountPrice) > 1
                          ? `-$${discountPrice} USD`
                          : `$${discountPrice} USD`}
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th
                        colSpan={"2"}
                        style={{
                          textAlign: "end",
                          fontSize: is4kScreen ? "1.7rem" : "",
                        }}
                      >
                        Total
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: is4kScreen ? "1.7rem" : "",
                        }}
                      >
                        $
                        {paymentType === 0
                          ? rushPrice.toFixed(2)
                          : (
                              parseInt(subTotal) +
                              parseInt(rushPrice) -
                              discountPrice
                            ).toFixed(2)} USD
                      </th>
                    </tr>
                  </tbody>
                </Table>
              </div>
              {/* <hr /> */}
              {/* <div style={{ paddingTop: "1rem" }}>
                <h4
                  style={{
                    fontSize: is4kScreen
                      ? "2rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isMediumScreen
                      ? " "
                      : "1.2rem",
                  }}
                >
                  Order Notes
                </h4>
                <hr />
                <ul>
                  {notesData.map((data, ind) => (
                    <li style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                      {data}
                    </li>
                  ))}
                </ul>
              </div> */}
              <hr />
              <Row className="my-3 ">
                <Col
                  className="mt-2 mt-md-0"
                  lg={4}
                  md={4}
                  sm={4}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: isSmallScreen ? "start" : "center",
                    alignItems: "center",
                  }}
                >
                  <Link
                    to="/"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        fontSize: isLargeScreen
                          ? "0.9rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : is4kScreen
                          ? "1.5rem"
                          : "1rem",
                      }}
                      icon={faHouse}
                    />
                    <h5
                      style={{
                        margin: "0px",
                        paddingLeft: "0.5rem",
                        fontSize: is4kScreen
                          ? "1.8rem"
                          : isXxlScreen
                          ? ""
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : "1rem",
                      }}
                    >
                      Home
                    </h5>
                  </Link>
                </Col>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  className="mt-2 mt-md-0"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: isSmallScreen ? "start" : "center",
                    alignItems: "center",
                  }}
                >
                  <Link
                    to="/order-page"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        fontSize: isLargeScreen
                          ? "0.9rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : is4kScreen
                          ? "1.5rem"
                          : "",
                      }}
                      icon={faFileImage}
                    />
                    <h5
                      style={{
                        margin: "0px",
                        paddingLeft: "0.5rem",
                        fontSize: is4kScreen
                          ? "1.8rem"
                          : isXxlScreen
                          ? ""
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : "1rem",
                      }}
                    >
                      {" "}
                      Order more reports
                    </h5>
                  </Link>
                </Col>
                <Col
                  lg={isLargeScreen && isPortrait1024 ? 4 : 3}
                  md={4}
                  sm={4}
                  className="mt-2 mt-md-0"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: isSmallScreen ? "start" : "center",
                    alignItems: "center",
                  }}
                >
                  <Link
                    to="/profile/billing-info"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        fontSize: isLargeScreen
                          ? "0.9rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : is4kScreen
                          ? "1.5rem"
                          : "",
                      }}
                      icon={faCircleInfo}
                    />
                    <h5
                      style={{
                        margin: "0px",
                        paddingLeft: "0.5rem",
                        fontSize: is4kScreen
                          ? "1.8rem"
                          : isXxlScreen
                          ? ""
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : "1rem",
                      }}
                    >
                      {" "}
                      Order History
                    </h5>
                  </Link>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}
